import { Box } from '@global-engineering-shared/gweb-material-ui';
import { ReactNode } from 'react';

import useStyles from 'features/Entity/components/EntityActionBar/components/EntityIconContainer/EntityIconContainer.styles';

interface EntityIconContainerProps {
  children: ReactNode;
}

const EntityIconContainer = (props: EntityIconContainerProps) => {
  const classes = useStyles();
  return <Box className={classes.entityIconContainer}>{props.children}</Box>;
};

export default EntityIconContainer;
